import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

type QueryKeyGetter<TVariables> = {
  getKey(variables: TVariables): unknown[];
};

export const useQueryInvalidator = () => {
  const queryClient = useQueryClient();

  const invalidateQuery = useCallback(<TVariables>(queryFn: QueryKeyGetter<TVariables>, variables?: TVariables) => {

    let queryKey = queryFn.getKey(variables as TVariables);
    queryKey = queryKey.filter(key => key != null);
    console.log('queryKey', queryKey);
    return queryClient.invalidateQueries({ queryKey });
  }, [queryClient]);

  return invalidateQuery;
};